import { connect } from "react-redux";
import EditPriceforDinMelScreen from "./EditPriceforDinMelScreen";
import { editDinMelPrice } from "src/storehouse/redux/actions";

export default connect(
  (state) => {
    return {
      profile: state.auth.profile,
    };
  },
  {
    editDinMelPrice,
  }
)(EditPriceforDinMelScreen);
